<h2 class="sr-only">{{ "EproidSuche" | translate }}</h2>
<form (ngSubmit)="onSubmit()" [meta]="eproid" #form="ngForm">
  <cap-form-row column-classes="col-md-2,col-md-3">
    <cap-form-control invalidKey="EingabeMussValideEproidSein" labelKey="EPROID">
      <input
        (ngModelChange)="eproid && (eproid.eproid = $event)"
        [ngModel]="eproid && eproid.eproid"
        #eproidTemplate
        autofocus
        id="eproid"
        name="eproid"
        type="text" />
    </cap-form-control>
  </cap-form-row>

  <div class="p-2" id="actionpane">
    <div class="rechtsbuendig">
      <button (click)="onReset()" class="btn btn-outline-primary btn-actionpane" type="button">{{ "Zurücksetzen" | translate }}</button>
      <button [disabled]="!form.form.valid" class="btn btn-primary btn-actionpane" type="submit">{{ "Suche" | translate }}</button>
    </div>
  </div>
</form>
